<section class="flex flex-col gap-4 xl:gap-6">
    <div class="flex flex-col-reverse gap-4 -mt-4 xl:flex-col xl:gap-6 xl:mt-0">
        <div class="flex justify-between items-center w-full">
            <h3 class="hidden xl:block xl:text-xl">센터 목록</h3>
            <div class="flex gap-2 items-center w-full xl:w-auto">
                <app-button
                    expand
                    class="min-w-max"
                    variant="outline"
                    routerLink="/center/find"
                    icon="material-symbols-light:edit-document"
                    >센터 찾기</app-button
                >
                <app-button
                    expand
                    class="min-w-max"
                    routerLink="/center/form"
                    icon="mynaui:heart-home-solid"
                    >센터 생성</app-button
                >
            </div>
        </div>

        <app-segment
            [(value)]="segment"
            (valueChange)="segmentChange()"
            [options]="segments"
        />
    </div>
    <div>
        <router-outlet />
    </div>
</section>
